import type {IconProp} from '@albert-io/atomic/atoms/Icon/Icon.react';

/**
 * Getting-started resources shared by the no-classes Welcome card and the has-classes Helpful Links
 * rail. Previously these URLs/links were module-private to GetStartedModule (and copy-pasted across
 * several legacy surfaces); centralizing them here keeps the two Home surfaces in sync.
 */

export const VIDEO_EMBED_URL = 'https://www.youtube.com/embed/6u82kKUcXsU?si=U7N5x4kt7QWg2OKc';
export const HELP_CENTER_URL = 'https://help.albert.io/en/collections/521216-teachers';
export const TEACHER_TALK_URL = 'https://app.lemcal.com/@albert-adoption-team/teacher-talk';
export const GETTING_STARTED_ARTICLE_URL =
  'https://help.albert.io/en/articles/1884980-teacher-onboarding-getting-started';

export interface HelpLink {
  label: string;
  href: string;
  icon: IconProp;
  chipClassName: string;
}

/** The "Book a free 15-min training" link, surfaced on both Home surfaces. */
export const BOOK_TRAINING_LINK: HelpLink = {
  label: 'Book a free 15-min personalized training session.',
  href: TEACHER_TALK_URL,
  icon: 'circle-user',
  chipClassName: 'background-blueberry-subtle content-blueberry'
};

/** The "Learn about…" help articles — rail-only (not shown in the no-classes Welcome card). */
export const LEARN_ABOUT_LINKS: HelpLink[] = [
  {
    label: 'Classrooms',
    href: GETTING_STARTED_ARTICLE_URL,
    icon: 'chalkboard',
    chipClassName: 'background-kiwi-subtle content-kiwi'
  },
  {
    label: 'Class & student data',
    href: 'https://help.albert.io/en/articles/6683815-how-do-i-use-reports-for-data-analysis-as-a-teacher',
    icon: 'chart-line',
    chipClassName: 'background-clementine-subtle content-clementine'
  },
  {
    label: 'Assigning student practice',
    href: 'https://help.albert.io/en/articles/4942861-how-can-i-assign-practice-on-albert',
    icon: 'file-lines',
    chipClassName: 'background-grape-subtle content-grape'
  },
  {
    label: 'Finding and assigning questions',
    href: 'https://help.albert.io/en/articles/1885026-how-do-i-search-for-questions-on-albert',
    icon: 'magnifying-glass',
    chipClassName: 'background-dragonfruit-subtle content-dragonfruit'
  }
];
